import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=4b2b2dc0&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b2dc0",
  null
  
)

export default component.exports